import consts from "consts"

export const programsWithSeoText = [consts.programs.touchePasAMonPoste]
